import { IPageData } from '../../interfaces/page.interface'

export class ResetPageData {
  static readonly type = '[page] Reset Page Data'
}

export class GetWhoToCallPage {
  static readonly type = '[page] Get Who To Call Page'
}

export class UpdateWhoToCallPage {
  static readonly type = '[page] Update Who To Call Page'
  constructor(public payload: IPageData) {}
}

export class GetPublicResourcesPage {
  static readonly type = '[page] Get Public Resources Page'
}

export class UpdatePublicResourcesPage {
  static readonly type = '[page] Update Public Resources Page'
  constructor(public payload: IPageData) {}
}

export class UploadPublicResources {
  static readonly type = '[page] Upload Public Resources'
  constructor(public files: File[]) {}
}

export class GetPublicResources {
  static readonly type = '[page] Get Public Resources'
}
